import * as React from "react";
import { graphql } from "gatsby";
import FollowUsSection from "../components/FollowUsSection";
import FooterSection from "../components/FooterSection";
import JoinCommunitySection from "../components/JoinCommunitySection";
import LatestNewsSection from "../components/LatestNewsSection";
import LearnSection from "../components/LearnSection";
import MilkHeader from "../components/MilkHeader";
import PageMeta from "../components/PageMeta";
import SubscribeSection from "../components/SubscribeSection";
import { I18nextContext, useTranslation } from "gatsby-plugin-react-i18next";

const CommunityPage = () => {
  const { t } = useTranslation();
  const langContext = React.useContext(I18nextContext);
  return (
    <>
      <main>
        <PageMeta
          title={t("Join the Milkomeda Community • Milkomeda")}
          description={t(
            "Milkomeda brings the most used smart-contract programming language across blockchains. Develop once, deploy everywhere."
          )}
          locale={t("en_US")}
          language={langContext.language}
        />
        <MilkHeader />
        <div>
          <JoinCommunitySection />
          <LearnSection />
          <LatestNewsSection />
          <FollowUsSection />
          <SubscribeSection />
        </div>
      </main>
      <FooterSection
        footerImage={"/images/footer-bg@2x.webp 2x, /images/footer-bg.webp 1x"}
      />
    </>
  );
};

export default CommunityPage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
